import { provideHttpClient, withFetch, withInterceptorsFromDi } from '@angular/common/http';
import { ApplicationConfig } from '@angular/core';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import {
  provideRouter,
  withEnabledBlockingInitialNavigation,
  withHashLocation,
  withInMemoryScrolling,
} from '@angular/router';
import { providePrimeNG } from 'primeng/config';
import { appRoutes } from './app.routes';
import { provideTranslateService, TranslateLoader } from '@ngx-translate/core';
import { authHttpInterceptorProviders } from '@shared/interceptors/auth.interceptor';
import { baseUrlInterceptorProviders } from '@shared/interceptors/baseUrl.interceptor';
import { StaticTranslationLoader } from '@shared/i18n/translation.static.loader';
import { ThemePreset } from './theme-presets';

// If we want to load translations from the server or local file uncomment the code below
// const httpLoaderFactory: (http: HttpClient) => TranslateHttpLoader = (http: HttpClient) => new TranslateHttpLoader(http, '/assets/i18n/', '.json');

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(
      appRoutes,
      withHashLocation(),
      withInMemoryScrolling({
        anchorScrolling: 'enabled',
        scrollPositionRestoration: 'enabled',
      }),
      withEnabledBlockingInitialNavigation(),
    ),
    provideHttpClient(withFetch(), withInterceptorsFromDi()),
    ...authHttpInterceptorProviders,
    ...baseUrlInterceptorProviders,
    provideAnimationsAsync(),
    providePrimeNG({ theme: { preset: ThemePreset, options: { darkModeSelector: '.app-dark' } } }),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useClass: StaticTranslationLoader, // for dynamic loader uncomment the code below
        // useFactory: httpLoaderFactory,
        // deps: [HttpClient]
      },
    }),
  ],
};
